import { TabType } from '../Store_KSK1080_R01';

// 공통 rowId 생성 함수
export const generateRowId = (item: any, tab: TabType): string => {
    switch (tab) {
        case 'item':
            // 품목별: 품목코드 + 브랜드코드로 고유성 보장
            return `${item.itemCd}-${item.brandCd || 'DEFAULT'}`;
        case 'warehouse':
            // 창고별: 물류센터 + 창고코드 + 품목코드 + 등급 + 브랜드
            return `${item.logicCenter}-${item.warehouseCd}-${item.itemCd}-${item.itemStatus}-${item.brandCd || 'DEFAULT'}`;
        case 'logiccenter':
            // 물류센터별: 물류센터코드 + 창고코드 + 품목코드 + 등급 + 브랜드
            return `${item.logicCenter}-${item.warehouseCd}-${item.itemCd}-${item.itemStatus}-${item.brandCd || 'DEFAULT'}`;
        case 'lot':
            // LOT별: 물류센터 + 창고 + 품목 + LOT번호로 고유성 보장
            return `${item.logicCenter}-${item.warehouseCd}-${item.itemCd}-${item.lotNo}`;
        case 'total':
            // 전체: 물류센터 + 창고 + 품목 + 등급 + 브랜드로 완전 고유성 보장
            return `${item.logicCenter}-${item.warehouseCd}-${item.itemCd}-${item.itemStatus}-${item.brandCd || 'DEFAULT'}`;
        default:
            return '';
    }
};
